import { useParams } from 'react-router-dom';

export const useCurrentProjectUserId = (): string | undefined => {
  const { userId } = useParams();

  return userId;
};
